const dashboard = {
  basicInformation: "Información Básica",
  planner: "Planificador",
  manufacturer: "Fabricante",
  reliabilityResume: "Resumen de Confiabilidad",
  theLastReliability: "El último informe de Confiabilidad fue",
  meanTimeBetweenFailure: "Tiempo medio entre fallos",
  moreMeanTimeBetweenFailure:
    "Esta métrica es el tiempo promedio de operación entre fallas para un activo o componente.",
  mechanicalAvailability: "Disponibilidad Mecánica",
  moreMechanicalAvailability:
    "El porcentaje de tiempo que el activo es capaz de realizar su función prevista (tiempo de actividad más tiempo de inactividad).",

  utilizationTime: "Tiempo de Utilización",
  moreUtilizationTime:
    "Tiempo en el que está programado la ejecución del activo dividido por el tiempo total disponible, expresado como porcentaje.",
  operatingTime: "Tiempo de Funcionamiento",
  moreOperatingTime:
    "Un intervalo de tiempo durante el cual el activo o componente está realizando su función requerida.",
  totalDowntime: "Tiempo de Inactividad Total",
  moreTotalDowntime:
    "La cantidad de tiempo que un activo no puede funcionar. La suma del tiempo de inactividad programado y el tiempo de inactividad no programado.",
  model: "Modelo",
  eventManager: "Administrador de Eventos",
  eventTitleInspection: "Nueva Inspección",
  eventTitleReliability: "REPORTE DE CONFIABILIDAD",
  eventMessage: {
    inspection: "Nueva inspección con estatus",
    reliability: "Nuevo reporte de confiabilidad con estatus",
    and: "y"
  },
  conditionMonitoringModule: "Módulo de monitoreo de condición",
  machineHealthIndex: "Índice de salud de la máquina",
  mechanincalCondition: "Condición operativa del equipo",
  reliabilitySummary: "Resumen de confiabilidad",
  mechanincalConditionOverTime: "Condición operativa a lo largo del tiempo",
  ago: "atras",
  hours: "horas",
  hour: "horas",
  minutes: "minutos",
  seconds: "segundos",
  dashboard: "Tablero",
  ranges: "Rangos",
  datepicker: {
    title: "Escoja Rango de Fechas",
    okbtn: "ACEPTAR",
    cancelbtn: "CANCELAR"
  },
  statuslights: {
    running: "En Servicio",
    standby: "En Reposo",
    maintenance: "En Mantenimiento",
    failure: "Fallando"
  },
  buttons: {
    gotoEquipment: "Equipos"
  },
  messages: {
    unitRules: "Unidad es requerida"
  },
  operationalValues: "Valores operacionales",
  graphics: "Gráficos",
  inspections: "Inspecciones",
  reliability: "Confiabilidad",
  documents: "Documentos",
  assetList: "Activos",
  repairLog: "Registro de reparaciones",
  equipmentDocs: "Documentos del Equipo",
  datasheet: "Hoja de datos",
  drawings: "Planos",
  addMultimedia: "Agregar Multimedia",
  fileInput: "Cargar Archivo",
  titleVariables: "Variables de Equipo",
  selectEquipmentsVariables: "Seleccione las variables del equipo",
  updateRanges: "Actualizar Rangos",
  canYouConfirm: "¿Puede confirmar que todos los campos son correctos?",
  checkFields: "Verificar campos"
};
export default dashboard;
